import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDownloadRestrictions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21 10.1636C20.863 8.95407 20.3647 7.82864 19.5832 6.96383C18.8016 6.09896 17.781 5.54359 16.6814 5.38471C16.2072 3.92565 15.2815 2.69634 14.066 1.91124C12.8506 1.12616 11.4227 0.835226 10.032 1.08972C8.64125 1.34421 7.37616 2.12793 6.45782 3.30349C5.53947 4.47905 5.02631 5.97187 5.00802 7.5211C3.94502 7.5211 2.92557 7.98489 2.17392 8.81082C1.42226 9.63687 1 10.7573 1 11.9255C1 13.0936 1.42226 14.2138 2.17392 15.0398C2.92557 15.8658 3.94502 16.3299 5.00802 16.3299H11.02",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 12V19",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 16L18 19L15 16",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.4802,
			cy: 9.40894,
			r: 2.79273,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 9.85616,
			y1: 11.3421,
			x2: 13.4632,
			y2: 7.06783,
			stroke: "currentColor"
		})
	]
});
export default SvgIconDownloadRestrictions;
